import React from 'react';

// Dedicated sort indicator (14px, design weight). Kept separate from IconChevronUp, which is a
// 20px chevron used for non-sort UI (map controls, accordions) and must not change.
const IconSorterUp = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M2.80005 9.09998L7.00005 4.89998L11.2 9.09998" stroke="#111111" strokeWidth="1.5" />
    </svg>
  );
};
export default IconSorterUp;
